<template>

  <v-container style="margin-bottom: 100px;">

    <v-row align="center" justify="center">

      <v-col cols="12" xl="6" lg="8" md="10" >

        <v-row align="center" justify="left" class="mt-3 mb-5">
          <v-col cols="12" md="6">
            <v-row align="center" justify="left" class="text-h5 text-center mb-2">
              <b style="color: #bf0529"> Academic collaboration</b>
            </v-row>
            <v-divider class="mt-2 mb-6"></v-divider>
            <v-row align="center" justify="left">
              <div line-height: 18px align="left">
                <p style="font-size: 18px; line-height: 21px; font color: #bf0529;">
                  <em>Faculty  and researchers from 
                    <span class="font-weight-bold" style="font-size: 16px; line-height: 18px;"><br>
                    </span>
                  </em>
                <span class="font-weight-bold" style="font-size: 20px; line-height: 18px;"><a href="https://www.harvard.edu/" target="_blank" class="texto-gris-link2">Harvard University  • </a> <a href="https://www.mit.edu/" target="_blank" class="texto-gris-link2">MIT</a></span><br>
                </p>
              </div>
            </v-row>
          </v-col>
 
          <v-col cols="12" md="6">
            <v-row align="center" justify="left" class="text-h5 text-center mb-2">
              <b>Sponsor</b>
           </v-row>
            <v-divider class="mt-2 mb-6"></v-divider>
            <v-row align="center" justify="left">
              <v-img contain max-width="146px" max-height="60px" src="@/assets/sponsor2.png"></v-img>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="left">
          <v-col class="text-h5 text-left mt-4 mb-2" cols="12" md="12">
            <b>Collaborators</b>
          </v-col>
        </v-row>

        <v-divider class="mb-1"></v-divider>

        <v-row align="center" justify="center">
          <v-col cols="12" md="10">
            <v-row align="center" justify="space-between">
              <v-col class="d-flex justify-center align-center" cols="6" md="3">
                <a href="https://hutchinscenter.fas.harvard.edu/home" target="blank">
                  <img src="@/assets/sponsors2024/hunter.png" alt="" />
                </a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="3">
                <a href="https://culturalagents.org/" target="blank">
                  <img src="@/assets/sponsors2024/culturalAgent.png" alt="" />
                </a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="3">
                <a href="https://cervantesobservatorio.fas.harvard.edu/" target="blank">
                  <img src="@/assets/sponsors2024/client-6-2.png" alt="" />
                </a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="3">
                <a href="https://rcc.harvard.edu/" target="blank">
                  <img src="@/assets/sponsors2024/hrcc.jpg" alt="" />
                </a>
              </v-col>

              <v-row justify="space-between">
                <v-col class="d-flex justify-center align-center" cols="6" md="2">
                  <a href="https://www.umass.edu/digitalcenter/" target="blank">
                    <img src="@/assets/sponsors2024/ndg.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://uees.edu.ec/" target="blank">
                    <img src="@/assets/sponsors2024/finis.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://fundacionbotin.org/" target="blank">
                    <img src="@/assets/sponsors2024/botin.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.iies.es/" target="blank">
                    <img src="@/assets/sponsors2024/client-16.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.consejo-estado.es/" target="blank">
                    <img src="@/assets/sponsors2024/colab-consejo-estado.jpg" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://oei.int/" target="blank">
                    <img src="@/assets/sponsors2024/oei.png" alt="" />
                  </a>
                </v-col>
              </v-row>

              <v-row justify="space-between">
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://ascofame.org.co/moodle/" target="blank">
                    <img src="@/assets/sponsors2024/colab-ascofame.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://usmp.edu.pe/" target="blank">
                    <img src="@/assets/sponsors2024/colab-unisanmartin.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="http://www.inaecu.com/" target="blank">
                    <img src="@/assets/sponsors2024/client8.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.universidadesdeinvestigacion.com/" target="blank">
                    <img src="@/assets/sponsors2024/client-12.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://rudecolombia.edu.co/" target="blank">
                    <img src="@/assets/sponsors2024/colab-rudecolombia.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.ucsm.edu.pe/" target="blank">
                    <img src="@/assets/sponsors2024/ucsm.gif" alt="" />
                  </a>
                </v-col>
              </v-row>

              <v-row justify="space-between">
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.uniovi.es/" target="blank">
                    <img src="@/assets/sponsors2024/client-17.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.unisabana.edu.co/" target="blank">
                    <img src="@/assets/sponsors2024/client-18.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://institutofranklin.net/" target="blank">
                    <img src="@/assets/sponsors2024/colab-ifranklin.jpg" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://institutofranklin.net/en/research/research-groups/friends-thoreau" target="blank">
                    <img src="@/assets/sponsors2024/colab-thoreau.jpg" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://www.fgua.es/" target="blank">
                    <img src="@/assets/sponsors2024/colab-unialcala.jpg" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="https://idea2.mit.edu/" target="blank">
                    <img src="@/assets/sponsors2024/idea.png" alt="" />
                  </a>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="6" md="1">
                  <a href="http://www.usfq.edu.ec/Paginas/Inicio.aspx" target="blank">
                    <img src="@/assets/sponsors2024/client-14.png" alt="" />
                  </a>
                </v-col>
              </v-row>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    isMobile() {
      if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent) ) { return true; } else { return false; }
    },
  },
};
</script>

<style lang="scss" scoped></style>
